import { webapi } from '@/api/webapi.ts';
import { cancelForwardAccumulatorRfs } from '@/store/forwardAccumulator/api/multiPass/cancelForwardAccumulatorRfs.ts';
import { executeForwardAccumulatorRfs } from '@/store/forwardAccumulator/api/multiPass/executeForwardAccumulatorRfs.ts';
import { requestForwardAccumulatorRfs } from '@/store/forwardAccumulator/api/multiPass/requestForwardAccumulatorQuote.ts';
import { checkForwardAccumulator } from '@/store/forwardAccumulator/api/tradeCapture/checkForwardAccumulator.ts';

export const forwardAccumulatorApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    checkForwardAccumulator: checkForwardAccumulator(builder),
    requestForwardAccumulatorRfs: requestForwardAccumulatorRfs(builder),
    cancelForwardAccumulatorRfs: cancelForwardAccumulatorRfs(builder),
    executeForwardAccumulatorRfs: executeForwardAccumulatorRfs(builder),
  }),
});

export const { useCheckForwardAccumulatorMutation, useCancelForwardAccumulatorRfsMutation } = forwardAccumulatorApi;

export const { matchFulfilled: matchCheckForwardAccumulatorFulfilled } =
  forwardAccumulatorApi.endpoints.checkForwardAccumulator;
